import { render } from "./ServiceCodes.vue?vue&type=template&id=464ebe94"
import script from "./ServiceCodes.vue?vue&type=script&lang=ts"
export * from "./ServiceCodes.vue?vue&type=script&lang=ts"
script.render = render

export default script